import React from 'react';

const TestMatchTabs = ({ items, activeItem, onClick }) => (
  <ul className="cr_tab_btns">
    {items?.map((item) => (
      <li key={item.value}>
        <span className={`cr_tab_btn ${activeItem === item.value ? 'active' : ''}`} onClick={() => onClick(item.value)}>
          {item.label}
        </span>
      </li>
    ))}
  </ul>
);

export default TestMatchTabs;
